module.exports = __webpack_public_path__ + "static/img/img-service-card-3.7203661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_conci/img-service-card-3.png
// module id = ejMN
// module chunks = 0